var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mwm-slick',{ref:"slick",attrs:{"options":_vm.slickOptions}},_vm._l((_vm.currentStore.reviews),function(review){return _c('reviews-carousel-card',{key:review.name,attrs:{"review":review}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }